var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ve-line',{attrs:{"data":_vm.chartdata,"settings":_vm.chartSettings,"judge-width":true,"grid":_vm.grid,"height":"260px","colors":_vm.colors,"legend-visible":false,"loading":true}})}
var staticRenderFns = []

export { render, staticRenderFns }